import { Badge, MantineColor } from '@mantine/core';
import { ProductEnum } from '@/api';
import type { ProductType } from '../types';

type ProductBadgeProps = {
  productType: ProductType;
};

const BADGE_CONFIG: Record<
  ProductType,
  { color: MantineColor; label: string; border?: string; backgroundColor?: string }
> = {
  [ProductEnum.POPUP]: {
    color: 'var(--mantine-color-yellow-9)',
    label: 'Popup',
    border: 'var(--mantine-color-orange-3)',
    backgroundColor: 'var(--mantine-color-orange-0)',
  },
  [ProductEnum.DELIVERY]: {
    color: 'var(--mantine-color-cyan-9)',
    backgroundColor: 'var(--mantine-color-cyan-0)',
    label: 'Delivery',
    border: 'var(--mantine-color-cyan-3)',
  },
};

const ProductBadge: React.FC<ProductBadgeProps> = ({ productType }) => {
  const { color, label, border, backgroundColor } = BADGE_CONFIG[productType];

  return (
    <Badge
      color={color}
      variant="light"
      radius="sm"
      size="md"
      styles={{
        label: { textTransform: 'none', color },
        root: {
          border: `1px solid ${border}`,
          backgroundColor,
        },
      }}
    >
      {label}
    </Badge>
  );
};

export default ProductBadge;
